import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Injectable, Optional} from '@angular/core';
import {throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';
import {StaticMethods} from '../model/GeneralModels';

@Injectable({
  providedIn: 'root'
})
export class AppSettingsService {
  // private maps: any;
  // private vocabulary: Map<string, string>;
  // private icons: Map<string, string>;

  constructor(private http: HttpClient) {
    // this.getSettings().subscribe((settings: any) => {
    //   this.icons = this.getInfo('icons', settings);
    //   console.log(this.icons);
    //   this.vocabulary = this.getInfo('vocabulary', settings);
    //   console.log(this.vocabulary);
    // });
  }

  // getInfo(label: string, settings: any): Map<string, string> {
  //   const targetObject = new Map<string, string>();
  //   Object.entries(settings[label]).forEach(
  //     ([key, value]: [string, string]) => targetObject.set(key, value)
  //   );
  //   return targetObject;
  // }

  // getVocabulary() {
  //   return this.vocabulary;
  // }

  // getSettings() {
  //   return this.http.get('http://localhost:4200/assets/config.json').pipe(catchError(this.handleError));
  // }

  // private handleError(err: HttpErrorResponse | any) {
  //   console.error('An error occurred', err);
  //   return throwError(err.message || err);
  // }

  public translateEnglish(englishValue: string, translationList ?: any): string {
    return translationList ? translationList[englishValue] || StaticMethods.getTranslation(englishValue)
      : StaticMethods.getTranslation(englishValue);
  }

  public getIcon(fieldName) {
    const icon = StaticMethods.getIcon(fieldName);
    return 'icon ' + icon;
  }

  public translateObject(object, translation?: any) {
    const translated: any = {};
    Object.entries(object).forEach(
      ([key, value]: [string, string]) => {
        translated[key] = this.translateEnglish(value, translation);
      }
    );
    return translated;
  }
}
